import config from "../config/config";

const path = (route) => `${config.BaseURL}${route}`;

export const apiUrl = {
  mobileOtp: path("/v1/user/send-otp"),
  verifyotp: path("/v1/user/verify-otp"),
  login: path("/v1/user/login"),
  userRegistration: path("/v1/user/signup"),

  // upload files
  uploadFile: (dir) => path(`/v1/file?dir=${dir}`),

  dashboard: {
    anayltics: path("/v1/dashboard/shopkeeper/stats")
  },

  branch: {
    addBranch: path("/v1/shop"),
    listing: path('/v1/shop/my-shops'),
    shopDetail: path('/v1/shop'),
    serviceListing: (shopId) => path(`/v1/shop/${shopId}/services`),
    serviceCategoryListing: (shopId, shopServiceId) => path(`/v1/shop/${shopId}/service/${shopServiceId}/categories`),
    addEditServiceCategory: (shopId, shopServiceId) => path(`/v1/shop/${shopId}/service/${shopServiceId}/categories`),
    addNewServiceCategory: (shopId, shopServiceId) => path(`/v1/shop/${shopId}/service/${shopServiceId}/new-categories`),
    addEditService: (shopId) => path(`/v1/shop/${shopId}/services`),
    printPrices: (shopId) => path(`/v1/shop/${shopId}/print-price`),
    addEditPrintPrices: (shopId) => path(`/v1/super-admin/shops/${shopId}/print-price`),

    // New end points
    addEditPrintSetting: (shopId) => path(`/v1/shop/${shopId}/print-setting`),
    printSettingCombinations: (shopId) => path(`/v1/shop/${shopId}/print-setting-combination`),
    addPrintingPrice: (shopId) => path(`/v1/shop/${shopId}/printing-price`),
    editPrintingPrice: (printingPriceId) => path(`/v1/shop/${printingPriceId}/printing-price`),
  },

  staff: {
    userStaff: path("/v1/user/staff"),
    shopStaff: path("/v1/shop/staff"),
    root: path("/v1/staff"),
    staffInfo: path("/v1/user/staff/details"),
  },

  orders: {
    root: path("/v1/order/my-orders"),
    orderCount: path("/v1/order/my-orders/count-summary"),
    updateStatus: path(`/v1/order`),
    detailById: path("/v1/order"),
    sendBookingReq: (orderId) => path(`/v1/delivery/send-booking-req/${orderId}`),
    assignRider: (orderId) => path(`/v1/delivery/assign-driver/${orderId}`),
    downloadInvoice: (orderId) => path(`/v1/invoice/${orderId}`),
    sendsoftcopy : path("/v1/order/send-softcopy")
  },

  masters: {
    services: path("/v1/master/service"),
    serviceCategories: () => path(`/v1/master/service-categories`),
    deliveryCharges: path(`/v1/master/delivery-charges`),
    paperSize: path(`/v1/master/print-config/printpaper-size`),
    paperType: path(`/v1/master/print-config/printpaper-type`),
    paperType: path(`/v1/master/print-config/printpaper-type`),
    passportSize: path(`/v1/master/print-config/passport-size`),
    passportAdditionalService: path(`/v1/master/print-config/passport-additonal-services`)
  },

  users: {
    user: path("/v1/user"),
    bankLink: path("/v1/payment/stripe-onboard-link"),
    updateUser: (userId) => path(`/v1/user/${userId}`),
    userChangePassword: path("/v1/user/change-password"),
    listing: path("/v1/super-admin/user"),
  },

  notifications: {
    notification: path("/v1/notification"),
    markNotification: path("/v1/:notificationId"),
    markAllRead: path("/v1/notification/all-mark-read")
  },

  payouts: {
    payoutListing: path("/v1/payouts"),
  },

  coupons: {
    couponListing: path("/v1/promotions/coupon"),
    coupon: path(`/v1/promotions/coupon`),

  },

  complaints: {
    listing: path("/v1/engagement/support/get-all-tickets"),
    complaintsDetailById: (id) => path(`/v1/engagement/support/${id}`),
    complaintsStatus: (id) => path(`/v1/engagement/support/update-ticket/${id}`),
    complaintsResponse: path('/v1/engagement/support/ticket/add-reponse'),
    responseDetail: path("/v1/engagement/support/ticket/responses"),
  },

  customers: {
    listing: path("/v1/shop/customers"),
  },

  feedback : {
    listing : path("/v1/engagement/feedback")
  },

  legals : path("/v1/master/legals")
}
